// extracted by mini-css-extract-plugin
module.exports = {"time":"style_time__usrM_"};